import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (wishlist.length === 0) { setProducts([]); return; }
    api.get("/products").then((r) => setProducts(r.data.filter((p) => wishlist.includes(p.id)))).catch(() => {});
  }, [wishlist]);

  return (
    <div className="max-w-[1600px] mx-auto px-5 sm:px-8 py-16 min-h-[70vh]">
      <p className="label-caps text-muted-foreground mb-3">Your saved pieces</p>
      <h1 className="font-serif-display text-5xl font-light tracking-tighter mb-12">Favorites</h1>
      {products.length === 0 ? (
        <div className="py-20 text-center"><Heart strokeWidth={1} className="w-12 h-12 text-muted-foreground mx-auto mb-6" /><p className="font-serif-display text-2xl text-muted-foreground">No favorites yet.</p><Link to="/shop" className="label-caps border-b border-ink mt-4 inline-block" data-testid="wishlist-shop">Explore the collection</Link></div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-testid="wishlist-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
